import React, { useEffect, useState } from "react";
import {
  contactIcon1,
  contactIcon2,
  contactIcon3,
  contactOtherBg,
} from "../../assets/images";
import { useTranslation } from "react-i18next";
import axios from "axios";
import OtherHero from "../../Components/Breadcrumb/OtherHero/OtherHero";

const Contact = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    message: "",
  });
  const [responseMessage, setResponseMessage] = useState({
    text: "",
    isError: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Form validation
    if (!formData.name || !formData.surname || !formData.message) {
      setResponseMessage({
        text: "Lütfen tüm alanları doldurunuz.",
        isError: true,
      });
      return;
    }

    try {
      // Backend'inizin beklediği form-data formatında gönderim
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("surname", formData.surname);
      formDataToSend.append("message", formData.message);

      console.log(formDataToSend);

      const response = await axios.post(
        "https://www.caspianrocksolutions.com/caspianrocksolutions/contact.php",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Backend yanıtını işleme
      const responseData = response.data;
      if (responseData.status === 1) {
        setResponseMessage({
          text: responseData.message || "Veri başarıyla gönderildi!",
          isError: false,
        });
        // Formu temizle
        setFormData({
          name: "",
          surname: "",
          message: "",
        });
      } else {
        setResponseMessage({
          text: responseData.message || "İşlem başarısız oldu",
          isError: true,
        });
      }
    } catch (error) {
      console.error("API Hatası:", error);
      let errorMessage = "Sunucuya bağlanırken bir hata oluştu";

      // Sunucudan gelen hatayı işleme
      if (error.response) {
        errorMessage =
          error.response.data?.message ||
          (error.response.data
            ? JSON.stringify(error.response.data)
            : error.message);
      }

      setResponseMessage({
        text: errorMessage,
        isError: true,
      });
    }
  };

  const [settings, setSettings] = useState([]);

  useEffect(() => {
    getSettings();
  }, []);

  async function getSettings() {
    try {
      // API'den verileri çekiyoruz
      const response = await axios.get(
        "https://www.caspianrocksolutions.com/caspianrocksolutions/settings.php"
      );
      setSettings(response.data.data[0]); // Gelen veriyi state'e kaydediyoruz
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error); // Hata durumunda mesaj yazdırıyoruz
    }
  }
  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${contactOtherBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <OtherHero
          title="Contact"
          content="Your next project starts with a conversation"
        />
      </div>
      <div className="bg-[#EDEDED] py-10 md:py-20 ">
        <div className="max-w-containerSm md:max-w-container mx-auto">
          <div className="md:flex bg-white">
            <div className="md:w-[640px] py-5 px-6 md:py-10 md:px-12">
              <p className="text-[22px] md:text-[28px] font-semibold font-firstFont text-[#B31F11]">
                {t("Contact Forms")}
              </p>
              <form className="mt-10" onSubmit={handleSubmit}>
                <p className="text-[#141615] font-medium text-[12px] md:text-[14px]">
                  {t("Name")}
                </p>
                <input
                  name="name"
                  className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#D5D5D5] mt-2 outline-none focus:ring-0 focus:outline-none"
                  placeholder={t("Enter your name")}
                  value={formData.name}
                  onChange={handleChange}
                  required
                />

                <p className="text-[#141615] font-medium text-[12px] md:text-[14px] mt-4">
                  {t("Surname")}
                </p>
                <input
                  name="surname"
                  className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#D5D5D5]  mt-2 outline-none focus:ring-0 focus:outline-none"
                  placeholder="Enter your surname"
                  value={formData.surname}
                  onChange={handleChange}
                  required
                />

                <p className="text-[#141615] font-medium text-[12px] md:text-[14px] mt-4">
                  {t("Message")}
                </p>
                <textarea
                  name="message"
                  className="rounded-lg min-h-[120px] w-full p-4 border-[1px] border-[#D5D5D5] mt-2 outline-none focus:ring-0 focus:outline-none resize-none"
                  placeholder={t("Write your message...")}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />

                <button
                  type="submit"
                  className="w-full h-[44px] rounded-[8px] bg-[#B31F11] text-[white] transition-all duration-300 ease-in-out transform hover:scale-105 shadow-md hover:shadow-xl font-semibold mt-[32px] md:mt-[40px]"
                >
                  {t("Göndər")}
                </button>

                {/* {responseMessage.text && (
                                <p className={`mt-4 text-center ${responseMessage.isError ? 'text-red-500' : 'text-green-500'}`}>
                                    {responseMessage.text}
                                </p>
                            )} */}
              </form>
            </div>
            <div className="md:w-[640px] text-[#222] mt-6 md:mt-0 py-5 px-4 md:py-10 md:px-20">
              <p className="text-[#B31F11] font-firstFont text-[22px] md:text-[28px] font-semibold">
                Contact İnformations
              </p>
              <div className="md:mt-[60px] mt-7 md:space-y-10 space-y-5">
                <div className="flex">
                  <img className="mr-6 w-7 h-7" src={contactIcon1}></img>
                  <p className="text-[20px]">{settings.phone1}</p>
                </div>
                <div className="flex">
                  <img className="mr-6 w-7 h-7" src={contactIcon2}></img>
                  <p className="text-[20px]">{settings.email}</p>
                </div>
                <div className="flex">
                  <img className="mr-6 w-7 h-7" src={contactIcon3}></img>
                  <p className="text-[20px]">
                    {settings.location}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-full mt-10">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3038.9102701076445!2d49.86949387582573!3d40.38868127144416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d17b24f2a4f%3A0xe1b88294b8b93edb!2sBeauttech%20Bab%C9%99k%20Plaza!5e0!3m2!1saz!2saz!4v1750680148361!5m2!1saz!2saz"
              style={{ width: "100%" }}
              height="389"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
